module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "transaction-box"
  }, [_c('title-date-component', {
    attrs: {
      "titleOption": _vm.titleOption
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "data-box"
  }, [_c('line-tips-component', {
    staticStyle: {
      "margin-top": "45px",
      "width": "150px"
    },
    attrs: {
      "lineTipsInfo": _vm.lineTipsInfo
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "data"
  }, [_c('section', [_c('span', {
    attrs: {
      "title": "浏览用户数量"
    }
  }, [_c('i', [_vm._v("访客数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.intentionUV)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "所售商品有下单行为的用户数量"
    }
  }, [_c('i', [_vm._v("下单用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.orderUserNum)))])]), _vm._v(" "), _c('section', [_c('span', {
    attrs: {
      "title": "产生的支付行为的用户数量"
    }
  }, [_c('i', [_vm._v("支付用户数")]), _vm._v(_vm._s(_vm._f("dataformat")(_vm.resultData.payUserNum)))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "funnel"
  }, [_c('section', [_c('span', [_vm._v("浏览")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("下单")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("支付")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef7bbaf8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataPlatform/menpiao/indexData/components/transaction/Transaction.vue
// module id = 827
// module chunks = 0